import {Asset} from '../../image/dto/asset';

export class GuideAuthor {
  profilePicture: Asset;
  title: string;
  subtitle: string;
  krugoId: string;
  companyId: string;
}
